import { useContext } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext'
import "./pages.css";

import TagComponent from '../../components/projectList/TagComponent';
import DarkButtonComponent from '../../components/commons/DarkButtonComponent';
import IconNotes from "../../graphics/Grafica App Mobile/Icon Notes.png"
import IconTopics from "../../graphics/Grafica App Mobile/Icon Files.png"

import { sortNotesByUpdatedAt } from '../../utils/UtilitaryFunctions';

import styles from './Mobile_ConferenceMenuPage.module.css'

const Mobile_ConferenceMenuPage = () => {
    const { mobileSocketRef, currentConference, currentUser, setCurrentNotesList, setCurrentError, setCurrentPage, setCurrentTopicsList } = useContext(GlobalMobileContext);

    const openNotes = () => {
        mobileSocketRef.current.emit("MOBILE_CONFERENCE_GET_NOTES", currentConference._id, currentUser._id, (callback) => {
            if (!callback.error) {
                let notes = sortNotesByUpdatedAt(callback.response)
                setCurrentNotesList(notes)
                setCurrentPage("Notes")
            } else {
                setCurrentError(callback.error)
            }
        });
    }

    const openTopics = () => {

        mobileSocketRef.current.emit("MOBILE_CONFERENCE_GET_TOPICS", currentConference._id, currentUser._id, (callback) => {
            if (!callback.error) {
                setCurrentTopicsList(callback.response)
                setCurrentPage("Topics")
            } else {
                setCurrentError(callback.error)
            }
        });
    }


    return (

        <section>
            <div className={styles.conferenceMenuContainer}>
                <div className={styles.cardTags}>
                    <TagComponent status={currentConference.type} text={currentConference.type} fontSize={8} height={14} margin={0} padding="2px 8px" />
                    <TagComponent status={currentConference.status} text={currentConference.status} fontSize={8} height={14} margin={0} padding="2px 8px" />
                </div>
                <div className={styles.pagetitle}>
                    <h1 className={styles.title}>{currentConference.name}</h1>
                </div>
                <div className={styles.cardMenu}>

                    <img src={IconNotes} height={200} style={{ marginTop: "-100px" }} />
                    <DarkButtonComponent
                        style={{ marginTop: "-30px", width: "80%", height: "38px", backgroundColor: "transparent", fontSize: "20px", lineHeight: "22px", borderRadius: "4px", border: "1px solid #33FFC8" }}
                        onClick={openNotes}>
                        Notes
                    </DarkButtonComponent>
                </div>
                <div className={styles.cardMenu} >
                    <img src={IconTopics} height={200} style={{ marginTop: "-100px" }} />
                    <DarkButtonComponent
                        style={{ marginTop: "-25px", width: "80%", height: "38px", backgroundColor: "transparent", fontSize: "20px", lineHeight: "22px", borderRadius: "4px", border: "1px solid #33FFC8" }}
                        onClick={openTopics}>
                        Topics
                    </DarkButtonComponent>
                </div>
            </div>
        </section>
    );
}

export default Mobile_ConferenceMenuPage;
